<template>
  <section id="not-found">
    <h1>404</h1>
  </section>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style lang="scss">
#app #not-found {
  min-width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  h1{
    font-family: "ForzaBold", Arial, sans-serif;
  }
}
</style>